module.exports = __webpack_public_path__ + "static/media/47_tn.22cbba17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/47_tn.jpg
// module id = 683
// module chunks = 0